import React from 'react';
import {Backdrop, CircularProgress, Stack, Typography} from '@mui/material';
import {bool, string} from 'prop-types';

const ProgressBackdrop = ({open, title}) => {
  return (
    <Backdrop
      open={open}
      sx={{zIndex: theme => theme.zIndex.modal + 1, color: 'white'}}
    >
      <Stack direction="column" spacing={2} alignItems="center">
        <CircularProgress size={60} />
        <Typography variant="h5">{`${title}...`}</Typography>
        <Typography variant="h6">
          This may take a few seconds, please wait
        </Typography>
      </Stack>
    </Backdrop>
  );
};

ProgressBackdrop.propTypes = {
  open: bool,
  title: string,
};

export default ProgressBackdrop;
